import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { Tooltip } from "@mui/material";

export const TankerType = {
	"*": "*",
	"G": "Gas",
	"C": "Chemical",
	"N": "Normal",
} as const;

export const ProductTankerType = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return <Select
		disableSearch
		fetchOptions={Object.keys(TankerType)}
		getOptionLabel={opt => getLabel(opt as keyof typeof TankerType)}
		multiple={false}
		value={value}
		onChange={onChange}
	/>;
};

function getLabel(tankerType: keyof typeof TankerType) {
	return tankerType === "*" ? "*" : `${tankerType}. ${TankerType[tankerType]}`;
}

// eslint-disable-next-line react-refresh/only-export-components
export function productTankerTypeField(tankerType: string | undefined | null) {
	if (!tankerType || !(tankerType in TankerType)) {
		return "-";
	}
	if (tankerType === "*") {
		return "*";
	}
	const key = tankerType as keyof typeof TankerType;
	return <Tooltip title={TankerType[key]} placement="right"><span>{key}</span></Tooltip>;
}
